export { default } from './SellerStamp';